import React from 'react';
import './FloatingWhatsApp.css';
import { FaWhatsapp } from 'react-icons/fa';

const FloatingWhatsApp = () => {
  const handleWhatsAppClick = () => {
    // Check if it's a mobile device
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      // For mobile devices
      window.location.href = 'whatsapp://send?phone=919890826344';
    } else {
      // For desktop devices
      window.open('https://web.whatsapp.com/send?phone=919890826344', '_blank');
    }
  };

  return (
    <div className="floating-whatsapp" onClick={handleWhatsAppClick}>
      <FaWhatsapp className="whatsapp-icon" />
    </div>
  );
};

export default FloatingWhatsApp;
